/** Small transient notice at the top centre ("已保存"). */
import Phaser from 'phaser';
import { GAME_W } from '@/core/config';
import { uiText } from './text';
import { Css, Slices, UiDepth } from './theme';
import type { UiRoot } from './UiRoot';

export class Toast {
  private container: Phaser.GameObjects.Container;
  private bar: Phaser.GameObjects.NineSlice;
  private text: Phaser.GameObjects.Text;
  private timer: Phaser.Time.TimerEvent | null = null;

  constructor(private readonly root: UiRoot) {
    const s = root.scene;
    this.container = s.add.container(GAME_W / 2, 18).setDepth(UiDepth.TOAST).setVisible(false).setAlpha(0);
    this.bar = s.add.nineslice(0, 0, Slices.bar.key, undefined, 120, 24, Slices.bar.l, Slices.bar.r, Slices.bar.t, Slices.bar.b).setOrigin(0.5);
    this.text = uiText(s, 0, 0, '', { fontSize: '13px', color: Css.parchment }).setOrigin(0.5);
    this.container.add([this.bar, this.text]);
  }

  show(message: string, ms = 1500): void {
    const s = this.root.scene;
    this.text.setText(message);
    this.bar.setSize(Math.max(80, Math.round(this.text.width) + 28), 24);
    this.container.setVisible(true);
    s.tweens.killTweensOf(this.container);
    this.timer?.remove(false);
    const reduce = this.root.reduceMotion();
    s.tweens.add({ targets: this.container, alpha: 1, duration: reduce ? 0 : 120 });
    this.timer = s.time.delayedCall(ms, () => {
      s.tweens.add({ targets: this.container, alpha: 0, duration: reduce ? 0 : 220, onComplete: () => this.container.setVisible(false) });
    });
  }

  destroy(): void { this.timer?.remove(false); this.container.destroy(true); }
}
